import { useSelector } from "react-redux";

export const usePrevRoute = (slug = "") => {
    const { prevRoute } = useSelector((state) => state.form);

    const { prevPath = "" } = prevRoute;
    const fromPage = prevPath === `/${slug}`;
    const fromOtherPage = !prevPath.split("/").includes(slug);
    return { fromOtherPage, fromPage, prevPath };
};

export default usePrevRoute;
